// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderChargemaster,
    ProviderChargemasterItem,
    ProviderChargemasterItemSortType,
    ProviderChargemasterSortType,
    SupportAppendChargemasterCsvPayload,
    SupportChargemaster,
    SupportChargemasterItem,
    SupportChargemasterItemSortType,
    SupportChargemasterSortType,
    SupportCreateChargemasterItemPayload,
    SupportCreateChargemasterPayload,
    SupportUpdateChargemasterCsvPayload,
    SupportUpdateChargemasterPayload,
    SupportAppendChargemasterCsvPayloadToJSON,
    SupportCreateChargemasterItemPayloadToJSON,
    SupportCreateChargemasterPayloadToJSON,
    SupportUpdateChargemasterCsvPayloadToJSON,
    SupportUpdateChargemasterPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderChargemasterFromJSON,
    ProviderChargemasterItemFromJSON,
    SupportChargemasterFromJSON,
    SupportChargemasterItemFromJSON,
} from '../models';

export interface AppendSupportChargemasterItemCsvRequest {
    id: string;
    supportAppendChargemasterCsvPayload: SupportAppendChargemasterCsvPayload;
}

export interface CreateSupportChargemasterRequest {
    supportCreateChargemasterPayload: SupportCreateChargemasterPayload;
}

export interface CreateSupportChargemasterCopyRequest {
    id: string;
}

export interface CreateSupportChargemasterItemRequest {
    id: string;
    supportCreateChargemasterItemPayload: SupportCreateChargemasterItemPayload;
}

export interface DisableSupportChargemasterRequest {
    id: string;
}

export interface DisableSupportChargemasterItemRequest {
    cid: string;
    iid: string;
}

export interface EnableSupportChargemasterRequest {
    id: string;
}

export interface EnableSupportChargemasterItemRequest {
    cid: string;
    iid: string;
}

export interface GetProviderChargemasterRequest {
    id: string;
}

export interface GetProviderChargemasterItemRequest {
    cid: string;
    iid: string;
}

export interface GetSupportChargemasterRequest {
    id: string;
}

export interface GetSupportChargemasterItemRequest {
    cid: string;
    iid: string;
}

export interface ListProviderChargemasterItemsRequest {
    id: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderChargemasterItemsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterAmount?: Array<string>;
    filterAccepted?: Array<string>;
    filterExpected?: Array<string>;
    filterMedicare?: Array<string>;
    filterPatient?: Array<string>;
    filterRvu?: Array<string>;
    filterAuthorization?: Array<string>;
    filterPaperwork?: Array<string>;
    filterDescription?: Array<string>;
    filterPlaceOfServiceType?: Array<string>;
    filterPayerId?: Array<string>;
    filterCoverageType?: Array<string>;
    filterProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterContractType?: Array<string>;
    sort?: Array<ProviderChargemasterItemSortType>;
}

export interface ListProviderChargemastersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderChargemastersOrderEnum>;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    sort?: Array<ProviderChargemasterSortType>;
}

export interface ListSupportChargemasterItemsRequest {
    id: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportChargemasterItemsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterAmount?: Array<string>;
    filterAccepted?: Array<string>;
    filterExpected?: Array<string>;
    filterMedicare?: Array<string>;
    filterPatient?: Array<string>;
    filterRvu?: Array<string>;
    filterAuthorization?: Array<string>;
    filterPaperwork?: Array<string>;
    filterDescription?: Array<string>;
    filterPlaceOfServiceType?: Array<string>;
    filterPayerId?: Array<string>;
    filterCoverageType?: Array<string>;
    filterProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterContractType?: Array<string>;
    sort?: Array<SupportChargemasterItemSortType>;
}

export interface ListSupportChargemasterItemsCsvRequest {
    id: string;
}

export interface ListSupportChargemastersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportChargemastersOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterActive?: string;
    filterName?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    sort?: Array<SupportChargemasterSortType>;
}

export interface UpdateSupportChargemasterRequest {
    id: string;
    supportUpdateChargemasterPayload: SupportUpdateChargemasterPayload;
}

export interface UpdateSupportChargemasterItemCsvRequest {
    id: string;
    supportUpdateChargemasterCsvPayload: SupportUpdateChargemasterCsvPayload;
}

/**
 * no description
 */
export class ChargemasterApi extends runtime.BaseAPI {

    /**
     * Appends a chargemaster with a csv of items
     * Appends a chargemaster with a csv of items
     */
    async appendSupportChargemasterItemCsvRaw(requestParameters: AppendSupportChargemasterItemCsvRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling appendSupportChargemasterItemCsv.');
        }

        if (requestParameters['supportAppendChargemasterCsvPayload'] === null || requestParameters['supportAppendChargemasterCsvPayload'] === undefined) {
            throw new runtime.RequiredError('supportAppendChargemasterCsvPayload','Required parameter requestParameters.supportAppendChargemasterCsvPayload was null or undefined when calling appendSupportChargemasterItemCsv.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/item/csv`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAppendChargemasterCsvPayloadToJSON(requestParameters['supportAppendChargemasterCsvPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Appends a chargemaster with a csv of items
     * Appends a chargemaster with a csv of items
     */
    async appendSupportChargemasterItemCsv(requestParameters: AppendSupportChargemasterItemCsvRequest): Promise<ObjectNoResponse> {
        const response = await this.appendSupportChargemasterItemCsvRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a chargemaster.
     * Create a chargemaster
     */
    async createSupportChargemasterRaw(requestParameters: CreateSupportChargemasterRequest): Promise<runtime.ApiResponse<SupportChargemaster>> {
        if (requestParameters['supportCreateChargemasterPayload'] === null || requestParameters['supportCreateChargemasterPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateChargemasterPayload','Required parameter requestParameters.supportCreateChargemasterPayload was null or undefined when calling createSupportChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateChargemasterPayloadToJSON(requestParameters['supportCreateChargemasterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportChargemasterFromJSON(jsonValue));
    }

    /**
     * Create a chargemaster.
     * Create a chargemaster
     */
    async createSupportChargemaster(requestParameters: CreateSupportChargemasterRequest): Promise<SupportChargemaster> {
        const response = await this.createSupportChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Copies a chargemaster
     * Copies a chargemaster
     */
    async createSupportChargemasterCopyRaw(requestParameters: CreateSupportChargemasterCopyRequest): Promise<runtime.ApiResponse<SupportChargemaster>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportChargemasterCopy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/copy`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportChargemasterFromJSON(jsonValue));
    }

    /**
     * Copies a chargemaster
     * Copies a chargemaster
     */
    async createSupportChargemasterCopy(requestParameters: CreateSupportChargemasterCopyRequest): Promise<SupportChargemaster> {
        const response = await this.createSupportChargemasterCopyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a chargemaster item
     * Create a chargemaster item
     */
    async createSupportChargemasterItemRaw(requestParameters: CreateSupportChargemasterItemRequest): Promise<runtime.ApiResponse<SupportChargemasterItem>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportChargemasterItem.');
        }

        if (requestParameters['supportCreateChargemasterItemPayload'] === null || requestParameters['supportCreateChargemasterItemPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateChargemasterItemPayload','Required parameter requestParameters.supportCreateChargemasterItemPayload was null or undefined when calling createSupportChargemasterItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/item`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateChargemasterItemPayloadToJSON(requestParameters['supportCreateChargemasterItemPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportChargemasterItemFromJSON(jsonValue));
    }

    /**
     * Create a chargemaster item
     * Create a chargemaster item
     */
    async createSupportChargemasterItem(requestParameters: CreateSupportChargemasterItemRequest): Promise<SupportChargemasterItem> {
        const response = await this.createSupportChargemasterItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a chargemaster
     * Disables a chargemaster
     */
    async disableSupportChargemasterRaw(requestParameters: DisableSupportChargemasterRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a chargemaster
     * Disables a chargemaster
     */
    async disableSupportChargemaster(requestParameters: DisableSupportChargemasterRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a chargemaster item
     * Disable a chargemaster item
     */
    async disableSupportChargemasterItemRaw(requestParameters: DisableSupportChargemasterItemRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling disableSupportChargemasterItem.');
        }

        if (requestParameters['iid'] === null || requestParameters['iid'] === undefined) {
            throw new runtime.RequiredError('iid','Required parameter requestParameters.iid was null or undefined when calling disableSupportChargemasterItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{cid}/item/{iid}/disable`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"iid"}}`, encodeURIComponent(String(requestParameters.iid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a chargemaster item
     * Disable a chargemaster item
     */
    async disableSupportChargemasterItem(requestParameters: DisableSupportChargemasterItemRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportChargemasterItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enables a disabled chargemaster
     * Enables a disabled chargemaster
     */
    async enableSupportChargemasterRaw(requestParameters: EnableSupportChargemasterRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableSupportChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enables a disabled chargemaster
     * Enables a disabled chargemaster
     */
    async enableSupportChargemaster(requestParameters: EnableSupportChargemasterRequest): Promise<ObjectNoResponse> {
        const response = await this.enableSupportChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a chargemaster item
     * Enable a chargemaster item
     */
    async enableSupportChargemasterItemRaw(requestParameters: EnableSupportChargemasterItemRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling enableSupportChargemasterItem.');
        }

        if (requestParameters['iid'] === null || requestParameters['iid'] === undefined) {
            throw new runtime.RequiredError('iid','Required parameter requestParameters.iid was null or undefined when calling enableSupportChargemasterItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{cid}/item/{iid}/enable`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"iid"}}`, encodeURIComponent(String(requestParameters.iid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable a chargemaster item
     * Enable a chargemaster item
     */
    async enableSupportChargemasterItem(requestParameters: EnableSupportChargemasterItemRequest): Promise<ObjectNoResponse> {
        const response = await this.enableSupportChargemasterItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a chargemaster
     * Get a chargemaster
     */
    async getProviderChargemasterRaw(requestParameters: GetProviderChargemasterRequest): Promise<runtime.ApiResponse<ProviderChargemaster>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/chargemaster/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderChargemasterFromJSON(jsonValue));
    }

    /**
     * Gets a chargemaster
     * Get a chargemaster
     */
    async getProviderChargemaster(requestParameters: GetProviderChargemasterRequest): Promise<ProviderChargemaster> {
        const response = await this.getProviderChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a chargemaster item
     * Gets a chargemaster item
     */
    async getProviderChargemasterItemRaw(requestParameters: GetProviderChargemasterItemRequest): Promise<runtime.ApiResponse<ProviderChargemasterItem>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling getProviderChargemasterItem.');
        }

        if (requestParameters['iid'] === null || requestParameters['iid'] === undefined) {
            throw new runtime.RequiredError('iid','Required parameter requestParameters.iid was null or undefined when calling getProviderChargemasterItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/chargemaster/{cid}/item/{iid}`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"iid"}}`, encodeURIComponent(String(requestParameters.iid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderChargemasterItemFromJSON(jsonValue));
    }

    /**
     * Gets a chargemaster item
     * Gets a chargemaster item
     */
    async getProviderChargemasterItem(requestParameters: GetProviderChargemasterItemRequest): Promise<ProviderChargemasterItem> {
        const response = await this.getProviderChargemasterItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a chargemaster
     * Get a chargemaster
     */
    async getSupportChargemasterRaw(requestParameters: GetSupportChargemasterRequest): Promise<runtime.ApiResponse<SupportChargemaster>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportChargemasterFromJSON(jsonValue));
    }

    /**
     * Gets a chargemaster
     * Get a chargemaster
     */
    async getSupportChargemaster(requestParameters: GetSupportChargemasterRequest): Promise<SupportChargemaster> {
        const response = await this.getSupportChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a chargemaster item
     * Gets a chargemaster item
     */
    async getSupportChargemasterItemRaw(requestParameters: GetSupportChargemasterItemRequest): Promise<runtime.ApiResponse<SupportChargemasterItem>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling getSupportChargemasterItem.');
        }

        if (requestParameters['iid'] === null || requestParameters['iid'] === undefined) {
            throw new runtime.RequiredError('iid','Required parameter requestParameters.iid was null or undefined when calling getSupportChargemasterItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{cid}/item/{iid}`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))).replace(`{${"iid"}}`, encodeURIComponent(String(requestParameters.iid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportChargemasterItemFromJSON(jsonValue));
    }

    /**
     * Gets a chargemaster item
     * Gets a chargemaster item
     */
    async getSupportChargemasterItem(requestParameters: GetSupportChargemasterItemRequest): Promise<SupportChargemasterItem> {
        const response = await this.getSupportChargemasterItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of chargemaster items
     * Get a list of chargemaster items
     */
    async listProviderChargemasterItemsRaw(requestParameters: ListProviderChargemasterItemsRequest): Promise<runtime.ApiResponse<Array<ProviderChargemasterItem>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listProviderChargemasterItems.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterAmount) {
            queryParameters['filterAmount'] = requestParameters.filterAmount;
        }

        if (requestParameters.filterAccepted) {
            queryParameters['filterAccepted'] = requestParameters.filterAccepted;
        }

        if (requestParameters.filterExpected) {
            queryParameters['filterExpected'] = requestParameters.filterExpected;
        }

        if (requestParameters.filterMedicare) {
            queryParameters['filterMedicare'] = requestParameters.filterMedicare;
        }

        if (requestParameters.filterPatient) {
            queryParameters['filterPatient'] = requestParameters.filterPatient;
        }

        if (requestParameters.filterRvu) {
            queryParameters['filterRvu'] = requestParameters.filterRvu;
        }

        if (requestParameters.filterAuthorization) {
            queryParameters['filterAuthorization'] = requestParameters.filterAuthorization;
        }

        if (requestParameters.filterPaperwork) {
            queryParameters['filterPaperwork'] = requestParameters.filterPaperwork;
        }

        if (requestParameters.filterDescription) {
            queryParameters['filterDescription'] = requestParameters.filterDescription;
        }

        if (requestParameters.filterPlaceOfServiceType) {
            queryParameters['filterPlaceOfServiceType'] = requestParameters.filterPlaceOfServiceType;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterCoverageType) {
            queryParameters['filterCoverageType'] = requestParameters.filterCoverageType;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterContractType) {
            queryParameters['filterContractType'] = requestParameters.filterContractType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/chargemaster/{id}/item`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderChargemasterItemFromJSON));
    }

    /**
     * Gets a list of chargemaster items
     * Get a list of chargemaster items
     */
    async listProviderChargemasterItems(requestParameters: ListProviderChargemasterItemsRequest): Promise<Array<ProviderChargemasterItem>> {
        const response = await this.listProviderChargemasterItemsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of chargemasters
     * Get a list of chargemasters
     */
    async listProviderChargemastersRaw(requestParameters: ListProviderChargemastersRequest): Promise<runtime.ApiResponse<Array<ProviderChargemaster>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/chargemaster`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderChargemasterFromJSON));
    }

    /**
     * Gets a list of chargemasters
     * Get a list of chargemasters
     */
    async listProviderChargemasters(requestParameters: ListProviderChargemastersRequest): Promise<Array<ProviderChargemaster>> {
        const response = await this.listProviderChargemastersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of chargemaster items
     * Get a list of chargemaster items
     */
    async listSupportChargemasterItemsRaw(requestParameters: ListSupportChargemasterItemsRequest): Promise<runtime.ApiResponse<Array<SupportChargemasterItem>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listSupportChargemasterItems.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterAmount) {
            queryParameters['filterAmount'] = requestParameters.filterAmount;
        }

        if (requestParameters.filterAccepted) {
            queryParameters['filterAccepted'] = requestParameters.filterAccepted;
        }

        if (requestParameters.filterExpected) {
            queryParameters['filterExpected'] = requestParameters.filterExpected;
        }

        if (requestParameters.filterMedicare) {
            queryParameters['filterMedicare'] = requestParameters.filterMedicare;
        }

        if (requestParameters.filterPatient) {
            queryParameters['filterPatient'] = requestParameters.filterPatient;
        }

        if (requestParameters.filterRvu) {
            queryParameters['filterRvu'] = requestParameters.filterRvu;
        }

        if (requestParameters.filterAuthorization) {
            queryParameters['filterAuthorization'] = requestParameters.filterAuthorization;
        }

        if (requestParameters.filterPaperwork) {
            queryParameters['filterPaperwork'] = requestParameters.filterPaperwork;
        }

        if (requestParameters.filterDescription) {
            queryParameters['filterDescription'] = requestParameters.filterDescription;
        }

        if (requestParameters.filterPlaceOfServiceType) {
            queryParameters['filterPlaceOfServiceType'] = requestParameters.filterPlaceOfServiceType;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterCoverageType) {
            queryParameters['filterCoverageType'] = requestParameters.filterCoverageType;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterContractType) {
            queryParameters['filterContractType'] = requestParameters.filterContractType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/item`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportChargemasterItemFromJSON));
    }

    /**
     * Gets a list of chargemaster items
     * Get a list of chargemaster items
     */
    async listSupportChargemasterItems(requestParameters: ListSupportChargemasterItemsRequest): Promise<Array<SupportChargemasterItem>> {
        const response = await this.listSupportChargemasterItemsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a csv of all chargemaster items
     * Get a csv of all chargemaster items
     */
    async listSupportChargemasterItemsCsvRaw(requestParameters: ListSupportChargemasterItemsCsvRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listSupportChargemasterItemsCsv.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/item/csv`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Gets a csv of all chargemaster items
     * Get a csv of all chargemaster items
     */
    async listSupportChargemasterItemsCsv(requestParameters: ListSupportChargemasterItemsCsvRequest): Promise<ObjectNoResponse> {
        const response = await this.listSupportChargemasterItemsCsvRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of chargemasters
     * Get a list of chargemasters
     */
    async listSupportChargemastersRaw(requestParameters: ListSupportChargemastersRequest): Promise<runtime.ApiResponse<Array<SupportChargemaster>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportChargemasterFromJSON));
    }

    /**
     * Gets a list of chargemasters
     * Get a list of chargemasters
     */
    async listSupportChargemasters(requestParameters: ListSupportChargemastersRequest): Promise<Array<SupportChargemaster>> {
        const response = await this.listSupportChargemastersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a chargemaster
     * Update a chargemaster
     */
    async updateSupportChargemasterRaw(requestParameters: UpdateSupportChargemasterRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportChargemaster.');
        }

        if (requestParameters['supportUpdateChargemasterPayload'] === null || requestParameters['supportUpdateChargemasterPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateChargemasterPayload','Required parameter requestParameters.supportUpdateChargemasterPayload was null or undefined when calling updateSupportChargemaster.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateChargemasterPayloadToJSON(requestParameters['supportUpdateChargemasterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a chargemaster
     * Update a chargemaster
     */
    async updateSupportChargemaster(requestParameters: UpdateSupportChargemasterRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportChargemasterRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a chargemaster with a csv of items
     * Replace a chargemaster with a csv of items
     */
    async updateSupportChargemasterItemCsvRaw(requestParameters: UpdateSupportChargemasterItemCsvRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportChargemasterItemCsv.');
        }

        if (requestParameters['supportUpdateChargemasterCsvPayload'] === null || requestParameters['supportUpdateChargemasterCsvPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateChargemasterCsvPayload','Required parameter requestParameters.supportUpdateChargemasterCsvPayload was null or undefined when calling updateSupportChargemasterItemCsv.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:chargemaster", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/chargemaster/{id}/item/csv`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateChargemasterCsvPayloadToJSON(requestParameters['supportUpdateChargemasterCsvPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a chargemaster with a csv of items
     * Replace a chargemaster with a csv of items
     */
    async updateSupportChargemasterItemCsv(requestParameters: UpdateSupportChargemasterItemCsvRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportChargemasterItemCsvRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderChargemasterItemsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderChargemastersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportChargemasterItemsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportChargemastersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
